// extracted by mini-css-extract-plugin
export default {"table_row":"Comments_table_row__leIFv","commentCell":"Comments_commentCell__pGx7B","dateCell":"Comments_dateCell__GFdF2","createdCell":"Comments_createdCell__nD-MK"};